export default __webpack_public_path__ + "static/media/biteBank2.5ed16b5a.png";